module.exports = __webpack_public_path__ + "assets/b37.png";


//////////////////
// WEBPACK FOOTER
// ./images/boomerang-frames/b37.png
// module id = 624
// module chunks = 0